import React from 'react';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

type Props = {
  title: string;
  value: number;
  icon: LucideIcon;
  color: 'primary' | 'green' | 'blue' | 'yellow' | 'red';
  delay?: number;
};

const colorClasses = {
  primary: {
    bg: 'bg-primary-50',
    text: 'text-primary-500',
    ring: 'ring-primary-500/20'
  },
  green: {
    bg: 'bg-green-50',
    text: 'text-green-500',
    ring: 'ring-green-500/20'
  },
  blue: {
    bg: 'bg-blue-50',
    text: 'text-blue-500',
    ring: 'ring-blue-500/20'
  },
  yellow: {
    bg: 'bg-yellow-50',
    text: 'text-yellow-500',
    ring: 'ring-yellow-500/20'
  },
  red: {
    bg: 'bg-red-50',
    text: 'text-red-500',
    ring: 'ring-red-500/20'
  }
};

export const StatCard = ({ title, value, icon: Icon, color, delay = 0 }: Props) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      className={`bg-white p-6 rounded-xl shadow-sm ring-1 ring-inset ${colorClasses[color].ring}`}
    >
      <div className="flex items-center gap-4">
        <div className={`p-3 rounded-lg ${colorClasses[color].bg}`}>
          <Icon className={colorClasses[color].text} size={24} />
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500">{title}</p>
          <p className={`text-2xl font-bold mt-1 ${colorClasses[color].text}`}>
            {value.toLocaleString('en-US')}
          </p>
        </div>
      </div>
    </motion.div>
  );
};